import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as css from './input.module.scss';
import cx from 'clsx';
export const FormElementLabel = ({ title, required }) => {
    if (!title) {
        return null;
    }
    return (_jsxs("div", { children: [title && _jsx("span", { className: cx('truncate', css.title), children: title }), required && _jsx("span", { className: css.required, children: " *" })] }));
};
